import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { api } from '../config'

const Hero = dynamic(() => import('../components/Hero'))
const Footer = dynamic(() => import('../components/Footer'))
const BookingPage = dynamic(() => import('../components/booking/Booking'))

const Booking = ({ getTerminals }) => {
  return (
    <>
      <Hero>
        <BookingPage getTerminals={getTerminals} />
      </Hero>
      <Footer />
    </>
  )
}
export default Booking

export async function getStaticProps() {
  const data = await api.get('/Terminals/GetFromTerminals')
  const getTerminals = await data.data

  if (!getTerminals) {
    return {
      notFound: true
    }
  }
  return {
    props: {
      getTerminals
    }, // will be passed to the page component as props
    revalidate: 60
  }
}
